

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import {KhoaPhong} from "@/models/khoaPhong";
import {DonViCreate} from "@/models/donViCreate";
import CDCRepository from "@/services/CDCRepository";
import {UpdatePassword} from "@/models/updatePassword";

export default {

  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const updatePass = ref({} as UpdatePassword);
    const passwordOld = ref('');
    const password1 = ref('');
    const password2 = ref('');

    const doUpdate = () => {
      if(password1.value.length < 6)
      {
        toast.add({
          severity: 'error',
          summary: 'Thất bại',
          detail: 'Mật khẩu mới nhỏ hơn 6 ký tự, vui lòng nhập lại',
          life: 4000
        });
      }
      else
      {
        if(password1.value != password2.value)
        {
          toast.add({
            severity: 'error',
            summary: 'Thất bại',
            detail: 'Mật khẩu mới và nhập lại mật khẩu mới không giống nhau, vui lòng kiểm tra lại',
            life: 4000
          });
        }
        else {
          var md5 = require("md5");

          updatePass.value.password = md5(passwordOld.value);
          updatePass.value.newPassword = password1.value;
          AuthRepository.updatePassword(updatePass.value)
              .then((response) => {
                toast.add({
                  severity: 'success',
                  summary: 'Cập nhật',
                  detail: 'Cập nhật mật khẩu thành công vào hệ thống',
                  life: 2000
                });
              })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2000
                });
              });
        };
      }

    }
    const valid = computed(()=> {
          return passwordOld.value&&password1.value&&password2.value;
        }

    );

    return {
      doUpdate,
      error,
      passwordOld,
      password1,
      password2,
      valid
    }
  }
}

